<template>
    <div>
        <div class="nrk">
            <Carousel :data='Performance' class="pc-display"/> 
            <CarouselMobile :data='Performance' class="mobile-display"/>
        </div>
        <Timeline :data='Performancether' :mane='nama'/>
    </div>
</template>

<script>
import{mapState} from'vuex';
import Timeline from'@/components/pc/Timeline'
export default {
    components:{
        Timeline
    },
    data() {
        return {
            nama:'—— 吉林医药设计院有限公司近年获奖项目 ——',
            boyd:{
                page:1,
                limit:100,
                type:1
            },
            boydSon:{
                page:1,
                limit:100,
                type:2
            }
        }
    },
    mounted() {
        this.$store.dispatch('PostPerformance',this.boyd);
        this.$store.dispatch('PostPerformance',this.boydSon);
    },
    computed:{
        ...mapState({
            Performance:state=>state.share.Performance,
            Performancether:state=>state.share.Performancether,
        })
    },
}
</script>
<style scoped>
    .mobile-display{
        display: none;
    }
    @media (max-width: 768px){
        .Servic p{
            font-size: 18px;
            padding: 18px 0;
            display: block;
            font-weight: bold;
        }
        .mobile-display{
            display: block;
        }
        .pc-display{
            display: none;
        }
    }
</style>